import React from 'react';
import styled from 'styled-components';
import { HEADER_HEIGHT, SHADOW_LIGHT, GREY_MEDIUM_LIGHT, SLATE, RAIN, SNOW } from '../constants/cssVars';
import { Link } from 'react-router-dom';
import { Menu } from './SlideOutMenu';
import { Logos } from './LoggedOutHeader';

const HeaderWrapper = styled.div`
  width: 100%;
  position: fixed;
  height: ${HEADER_HEIGHT}px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  z-index: 10;
  box-shadow: ${SHADOW_LIGHT};
  border-bottom: 1px solid ${GREY_MEDIUM_LIGHT};
  background-image: radial-gradient(circle at right, #526d80, ${RAIN});
`;

const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderOffset = styled.div`
  width: 100%;
  height: ${HEADER_HEIGHT}px;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-family: 'Open Sans Condensed', sans-serif;
  text-transform: uppercase;
  font-size: 1.2em;
  > a {
    margin: 0px 15px;
    text-decoration: none;
    font-weight: 600;
    color: ${SNOW};
    text-align: center;
    &:hover {
      color: ${SLATE};
    }
  }
  @media only screen and (max-width: 700px) {
    font-size: 1em;
  }  
`;

const MenuWrapper = styled.div`
  min-width: 300px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 700px) {
    min-width: 0px;
  }  
`

export const Header = () => {
  return (
    <header>
      <HeaderWrapper>
        <HeaderContent>
          <Nav>
            <Logos />
            <Link to='/app'>MS² Admin Review Tool</Link>
            <MenuWrapper>
              <Menu />
            </MenuWrapper>
          </Nav>
        </HeaderContent>
      </HeaderWrapper>
      <HeaderOffset />
    </header>
  )
}